export default __webpack_public_path__ + "static/media/sponsor2.f4af4137.jpg";